var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoLabel',{attrs:{"label":_vm.field.label}},[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.compResponse))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }